import Input from "../../components/custom/forms/Input";

const Reporte = ({
  formData,
  validate,
  handleChange,
  handleSubmit,
  loadingSubmit,
  // Usuarios
  usuarios,
  searchUsuario,
  setSearchUsuario,
  handleSelectUsuario,
  loadingUsuarios,
  selectedUsuario,
  // Eventos
  eventos,
  searchEvento,
  setSearchEvento,
  handleSelectEvento,
  loadingEventos,
  selectedEvento,
  // Entradas
  entradas,
  handleSelectEntrada,
  // Fechas
  fechasDisponibles,
}) => {
  return (
    <div
      className="container-md bg-light px-3 py-5"
      style={{ maxWidth: "1000px", borderRadius: "10px" }}
    >
      <div className="row">
        <div className="col-12">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h2 className="fw-bold mb-0">Crear Nuevo Reporte</h2>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Información Principal */}
            <div className="card mb-4">
              <div className="card-header bg-white">
                <h5 className="mb-0">Información Principal</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Buscador de Usuario */}
                  <div className="col-md-6">
                    <div className="form-group my-2">
                      <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                        Usuario *
                      </label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className={`form-control border ${validate.usuarios_id.status ? "border-danger" : ""}`}
                          placeholder="Buscar usuario por nombre..."
                          value={searchUsuario}
                          onChange={(e) => setSearchUsuario(e.target.value)}
                          onFocus={() => setSearchUsuario("")}
                        />
                        {searchUsuario && !selectedUsuario && (
                          <div className="position-absolute w-100 bg-white border shadow-sm" style={{ zIndex: 1000, maxHeight: "300px", overflowY: "auto" }}>
                            {loadingUsuarios ? (
                              <div className="p-3 text-center">
                                <div className="spinner-border spinner-border-sm" role="status">
                                  <span className="visually-hidden">Cargando...</span>
                                </div>
                              </div>
                            ) : usuarios.length > 0 ? (
                              usuarios.map((usuario) => (
                                <div
                                  key={usuario.id}
                                  className="p-2 cursor-pointer hover-bg-light"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSelectUsuario(usuario)}
                                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                                >
                                  <div className="fw-bold">{usuario.nombre}</div>
                                  <small className="text-muted">
                                    {usuario.email} - ID: {usuario.id}
                                  </small>
                                </div>
                              ))
                            ) : (
                              <div className="p-3 text-center text-muted">
                                No se encontraron usuarios
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {validate.usuarios_id.status && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {validate.usuarios_id.msg}
                        </div>
                      )}
                      {selectedUsuario && (
                        <div className="mt-2 p-2 bg-light rounded">
                          <small className="text-success">
                            ✓ Usuario seleccionado: {selectedUsuario.nombre} (ID: {selectedUsuario.id})
                          </small>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Buscador de Evento */}
                  <div className="col-md-6">
                    <div className="form-group my-2">
                      <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                        Evento *
                      </label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className={`form-control border ${validate.eventos_id.status ? "border-danger" : ""}`}
                          placeholder="Buscar evento por nombre..."
                          value={searchEvento}
                          onChange={(e) => setSearchEvento(e.target.value)}
                          onFocus={() => setSearchEvento("")}
                        />
                        {searchEvento && !selectedEvento && (
                          <div className="position-absolute w-100 bg-white border shadow-sm" style={{ zIndex: 1000, maxHeight: "300px", overflowY: "auto" }}>
                            {loadingEventos ? (
                              <div className="p-3 text-center">
                                <div className="spinner-border spinner-border-sm" role="status">
                                  <span className="visually-hidden">Cargando...</span>
                                </div>
                              </div>
                            ) : eventos.length > 0 ? (
                              eventos.map((evento) => (
                                <div
                                  key={evento.id}
                                  className="p-2 cursor-pointer hover-bg-light"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSelectEvento(evento)}
                                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                                >
                                  <div className="fw-bold">{evento.nombre}</div>
                                  <small className="text-muted">ID: {evento.id}</small>
                                </div>
                              ))
                            ) : (
                              <div className="p-3 text-center text-muted">
                                No se encontraron eventos
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {validate.eventos_id.status && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {validate.eventos_id.msg}
                        </div>
                      )}
                      {selectedEvento && (
                        <div className="mt-2 p-2 bg-light rounded">
                          <small className="text-success">
                            ✓ Evento seleccionado: {selectedEvento.nombre} (ID: {selectedEvento.id})
                          </small>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Selector de Entrada */}
                  <div className="col-md-6">
                    <div className="form-group my-2">
                      <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                        Entrada *
                      </label>
                      <select
                        className={`form-control border ${validate.entradas_id.status ? "border-danger" : ""}`}
                        name="entradas_id"
                        value={formData.entradas_id}
                        onChange={handleSelectEntrada}
                        disabled={!selectedEvento || entradas.length === 0}
                      >
                        <option value="">Seleccione una entrada</option>
                        {entradas.map((entrada) => (
                          <option key={entrada.id} value={entrada.id}>
                            {entrada.nombre} - ${entrada.precio}
                          </option>
                        ))}
                      </select>
                      {validate.entradas_id.status && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {validate.entradas_id.msg}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Selector de Fecha */}
                  <div className="col-md-6">
                    <div className="form-group my-2">
                      <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                        Fecha del Evento *
                      </label>
                      <select
                        className={`form-control border ${validate.fecha.status ? "border-danger" : ""}`}
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        disabled={!selectedEvento || fechasDisponibles.length === 0}
                      >
                        <option value="">Seleccione una fecha</option>
                        {fechasDisponibles.map((fecha, index) => {
                          return fecha.fechas.map((dia) => {
                            return <option key={index} value={`${dia} HORA: ${fecha.hora}`}>
                            {`${dia} HORA: ${fecha.hora}`}
                          </option>
                          })
                        })}
                      </select>
                      {validate.fecha.status && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {validate.fecha.msg}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <Input
                      label="Decidir ID"
                      name="decidir_id"
                      type="text"
                      value={formData.decidir_id}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="ID de Decidir"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Información de la Entrada */}
            <div className="card mb-4">
              <div className="card-header bg-white">
                <h5 className="mb-0">Información de la Entrada</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <Input
                      label="Cantidad *"
                      name="cantidad"
                      type="number"
                      value={formData.cantidad}
                      onChange={handleChange}
                      validate={validate.cantidad}
                      placeholder="Cantidad de entradas"
                    />
                  </div>
                  <div className="col-md-4">
                    <Input
                      label="Precio Unitario *"
                      name="unidad"
                      type="number"
                      step="0.01"
                      value={formData.unidad}
                      onChange={handleChange}
                      validate={validate.unidad}
                      placeholder="Precio por unidad"
                      disabled
                    />
                  </div>
                  <div className="col-md-4">
                    <Input
                      label="Total *"
                      name="total"
                      type="number"
                      step="0.01"
                      value={formData.total}
                      onChange={handleChange}
                      validate={validate.total}
                      placeholder="Total a pagar"
                      disabled
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Código (Generado automáticamente)"
                      name="codigo"
                      type="text"
                      value={formData.codigo}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Código de la entrada"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Descuentos y Comisiones */}
            <div className="card mb-4">
              <div className="card-header bg-white">
                <h5 className="mb-0">Descuentos y Comisiones</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <Input
                      label="Código Descuento"
                      name="codigo_descuento"
                      type="text"
                      value={formData.codigo_descuento}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Código de cupón"
                    />
                  </div>
                  <div className="col-md-4">
                    <Input
                      label="Descuento (%)"
                      name="descuento"
                      type="number"
                      step="0.01"
                      value={formData.descuento}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Porcentaje de descuento"
                    />
                  </div>
                  <div className="col-md-4">
                    <Input
                      label="Multiplicador"
                      name="multiplicador"
                      type="number"
                      step="0.01"
                      value={formData.multiplicador}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Multiplicador"
                      disabled
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Comisión (%)"
                      name="comision"
                      type="number"
                      step="0.01"
                      value={formData.comision}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Porcentaje de comisión"
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="ID de Comisión (Fijo: 2)"
                      name="comisiones_id"
                      type="number"
                      value={formData.comisiones_id}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="ID de la comisión"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Información del Cliente */}
            <div className="card mb-4">
              <div className="card-header bg-white">
                <h5 className="mb-0">Información del Cliente</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      label="Nombre del Cliente *"
                      name="nombre_cliente"
                      type="text"
                      value={formData.nombre_cliente}
                      onChange={handleChange}
                      validate={validate.nombre_cliente}
                      placeholder="Nombre completo"
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="DNI del Cliente"
                      name="dni_cliente"
                      type="text"
                      value={formData.dni_cliente}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Número de documento"
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Email del Cliente *"
                      name="email_cliente"
                      type="email"
                      value={formData.email_cliente}
                      onChange={handleChange}
                      validate={validate.email_cliente}
                      placeholder="correo@ejemplo.com"
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Teléfono del Cliente"
                      name="telefono_cliente"
                      type="text"
                      value={formData.telefono_cliente}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Número de teléfono"
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="form-group my-2">
                      <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                        Estado de Ingreso
                      </label>
                      <select
                        className="form-control border"
                        name="ingreso"
                        value={formData.ingreso}
                        onChange={handleChange}
                      >
                        <option value="ESPERA">ESPERA</option>
                        <option value="CONCURRIO">CONCURRIÓ</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Estado y Membresía */}
            <div className="card mb-4">
              <div className="card-header bg-white">
                <h5 className="mb-0">Estado y Membresía</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group my-2">
                      <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                        Estado *
                      </label>
                      <select
                        className="form-control border"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                      >
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="INACTIVO">INACTIVO</option>
                        <option value="REEMBOLSO">REEMBOLSO</option>
                        <option value="RECHAZADO">RECHAZADO</option>
                        <option value="LIQUIDADO">LIQUIDADO</option>
                      </select>
                      {validate.status.status && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {validate.status.msg}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Código de Membresía"
                      name="membership_code"
                      type="text"
                      value={formData.membership_code}
                      onChange={handleChange}
                      validate={{ status: false, msg: "" }}
                      placeholder="Código de membresía"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Botones de Acción */}
            <div className="d-flex justify-content-end gap-2">
              <button type="button" className="btn btn-outline-secondary" disabled={loadingSubmit}>
                Cancelar
              </button>
              <button
                type="submit"
                className="btn"
                style={{ backgroundColor: "#ea580c", color: "white" }}
                disabled={loadingSubmit}
              >
                {loadingSubmit ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Creando...
                  </>
                ) : (
                  "Crear Reporte"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Reporte;
